module.exports = __webpack_public_path__ + "img/pick3.103bce58.png";